export default __webpack_public_path__ + "static/media/dropdown.f3f1e7c6.svg";